export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///1FN9QAAAOXl5SH5BAAAAAAALAAAAAASAAwAAAIdjI+py+2vhJy02ouz3naAD4YiMHjj+ZUoWrbu+xYAOw=="